import { FC } from 'react'
import { Box } from '../../Box'
import { FileRejection, OnRemove } from '../types'
import { FileItem } from './FileItem'

interface Props {
  filesRejections: FileRejection[]
  isDisabled?: boolean
  onRemove: OnRemove
}

export const FileErrorList: FC<Props> = ({ filesRejections, isDisabled, onRemove }) => {
  return (
    <Box column gap="8">
      {filesRejections.map((rejection, index) => (
        <FileItem
          key={index}
          file={rejection.file}
          title={`${rejection.file.name} - ${rejection.message}`}
          index={index}
          status="error"
          isDisabled={isDisabled}
          onRemove={onRemove}
        />
      ))}
    </Box>
  )
}
